import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {firstValueFrom} from 'rxjs';

declare var $: any;

@Component({
  selector: 'app-withdraw-dialog',
  templateUrl: './withdraw-dialog.component.html',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  styleUrls: ['./withdraw-dialog.component.scss']
})
export class WithdrawDialogComponent implements OnInit {
  @Input() maxAmount = 0;
  @Output() confirm = new EventEmitter<number>();
  @ViewChild('withdrawModal') modal: ElementRef;

  withdrawAmount: number;
  errorMessage = '';
  submitting = false; // Add this property for tracking loading state

  constructor(private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.withdrawAmount = this.maxAmount; // Default to the full balance
  }

  show() {
    this.submitting = false; // Reset submitting state when showing the dialog
    $(this.modal.nativeElement).modal('show');
  }

  hide() {
    $(this.modal.nativeElement).modal('hide');
  }

  onCancel(): void {
    if (!this.submitting) { // Only allow cancel if not submitting
      this.hide();
    }
  }

  onSubmit(): void {
    if (this.submitting) {
      return; // Prevent multiple submissions
    }

    if (!this.withdrawAmount) {
      firstValueFrom(this.translate.get('Please enter an amount')).then(value => {
        this.errorMessage = value;
      }).catch(reason => {
        this.errorMessage = reason;
      });
      return;
    }

    if (this.withdrawAmount <= 0) {
      firstValueFrom(this.translate.get('Amount must be greater than zero')).then(value => {
        this.errorMessage = value;
      }).catch(reason => {
        this.errorMessage = reason;
      });
      return;
    }

    if (this.withdrawAmount > this.maxAmount) {
      firstValueFrom(this.translate.get('Amount cannot exceed your balance')).then(value => {
        this.errorMessage = value;
      }).catch(reason => {
        this.errorMessage = reason;
      });
      return;
    }

    this.submitting = true; // Set submitting to true before emitting the event
    this.confirm.emit(this.withdrawAmount);
    // Don't hide here - let the parent component hide after successful submission
  }
}
